// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2KNxZ","left":"styles_left__2k1Tl"};